// Copyright 2020 Cartesi Pte. Ltd.
export const loadWaves = () => {
    return require('./resources/waves.json');
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2F2ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy93YXZlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLG1DQUFtQztBQWNuQyxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsR0FBcUIsRUFBRTtJQUM1QyxPQUFPLE9BQU8sQ0FBQyx3QkFBd0IsQ0FBQyxDQUFDO0FBQzdDLENBQUMsQ0FBQyJ9